<template>
  <div>
  <slot />
  </div>
</template>

<script>
export default {
  name: 'LoginLayout',
};
</script>

<style scoped>

</style>
